<template>
  <div class="journal-redirect-page">
    <div class="redirect-content">
      <a-spin size="large" />
      <h2>Redirecting to Indonesian Journal of Cardiology...</h2>
      <p>You will be redirected to the journal website in a moment.</p>
      <a href="https://www.ijconline.id/index.php/ijc" target="_blank" class="manual-link">
        Click here if you are not redirected automatically
      </a>
    </div>
  </div>
</template>

<script>
import { onMounted } from 'vue'

export default {
  name: 'IndonesianJournal',
  setup() {
    onMounted(() => {
      // Open in new tab and redirect automatically
      window.open('https://www.ijconline.id/index.php/ijc', '_blank')

      // Optionally, go back to previous page after a short delay
      setTimeout(() => {
        window.history.back()
      }, 500)
    })
  },
}
</script>

<style scoped>
.journal-redirect-page {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8f9fa;
}

.redirect-content {
  text-align: center;
  padding: 3rem;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  max-width: 500px;
}

.redirect-content h2 {
  font-size: 1.5rem;
  color: #333;
  margin: 1.5rem 0 1rem;
}

.redirect-content p {
  color: #666;
  margin-bottom: 1.5rem;
}

.manual-link {
  display: inline-block;
  color: #e10f28;
  font-weight: 500;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border: 1px solid #e10f28;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.manual-link:hover {
  background-color: #e10f28;
  color: white;
}
</style>
